<div class="tap-top" (click)="tapToTop()" [ngStyle]="{ 'display': show ? 'block' : 'none' }">
    <app-feathericon [icon]="'chevrons-up'"></app-feathericon>
</div>
